webpackJsonp([64],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(98);

/***/ }),

/***/ 98:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[97]);


// WEBPACK FOOTER //
// m-quote.js